import { Controller } from "react-hook-form";
import { OperatorType } from "~/pages/space/workspaces/components/ConditionBuilder/types";
import { useWorkspaceConditionOperator } from "./hooks/useWorkspaceConditionOperator";
import { WorkspaceConditionOperatorDropdown } from "./ConditionOperatorDropdown/WorkspaceConditionOperatorDropdown";

interface WorkspaceConditionOperatorProps {
  selectionIndex: number;
  conditionIndex: number;
  isReadonly: boolean;
  type?: OperatorType;
}

export const WorkspaceConditionOperator = ({
  isReadonly,
  conditionIndex,
  selectionIndex,
  type: typeFromProps,
}: WorkspaceConditionOperatorProps) => {
  const { name, defaultValue, control, type } = useWorkspaceConditionOperator({
    selectionIndex,
    conditionIndex,
    type: typeFromProps,
  });

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <WorkspaceConditionOperatorDropdown
          type={typeFromProps || type}
          isReadonly={isReadonly}
          defaultValue={defaultValue}
          {...field}
        />
      )}
    />
  );
};
